import {
    FETCH_EMAIL_NOTIFICATIONS,
    FETCH_EMAIL_NOTIFICATIONS_FETCHING,
    FETCH_EMAIL_NOTIFICATIONS_SUCCESS,
    FETCH_EMAIL_NOTIFICATIONS_FAIL,
    UPDATE_EMAIL_NOTIFICATIONS,
    UPDATE_EMAIL_NOTIFICATIONS_UPDATING,
    UPDATE_EMAIL_NOTIFICATIONS_SUCCESS,
    UPDATE_EMAIL_NOTIFICATIONS_FAIL
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    emailNotifications: {},
    emailNotificationsFetching: false,
    emailNotificationsFetchSuccess: false,
    emailNotificationsFetchFail: false,
    emailNotificationsUpdating: false,
    emailNotificationsUpdateFail: false,
    emailNotificationsUpdateSuccess: false
};

// ======= Fetching Handlers =======
const emailNotificationsFetching = (state) => {
    return {
        ...state,
        emailNotificationsFetching: true,
        emailNotificationsFetchSuccess: false,
        emailNotificationsFetchFail: false
    };
};

const emailNotificationsFetchFinished = (success) => (state, action) => {
    return {
        ...state,
        emailNotifications: success ? action.emailNotifications : state.emailNotifications,
        emailNotificationsFetching: false,
        emailNotificationsFetchSuccess: success,
        emailNotificationsFetchFail: !success
    };
};

// ======= Updating Handlers =======
const updateEmailNotificationsUpdating = (state) => {
    return {
        ...state,
        emailNotificationsUpdating: true,
        emailNotificationsUpdateFail: false,
        emailNotificationsUpdateSuccess: false
    };
};

const updateEmailNotificationsUpdateSuccess = (state, action) => {
    return {
        ...state,
        emailNotifications: {
            ...state.emailNotifications,
            ...action.updatedEmailNotifications
        },
        emailNotificationsUpdating: false,
        emailNotificationsUpdateFail: false,
        emailNotificationsUpdateSuccess: true
    };
};

const updateEmailNotificationsUpdateFail = (state) => {
    return {
        ...state,
        emailNotificationsUpdating: false,
        emailNotificationsUpdateFail: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_EMAIL_NOTIFICATIONS_FETCHING]: emailNotificationsFetching,
    [FETCH_EMAIL_NOTIFICATIONS_SUCCESS]: emailNotificationsFetchFinished(true),
    [FETCH_EMAIL_NOTIFICATIONS_FAIL]: emailNotificationsFetchFinished(false),
    [UPDATE_EMAIL_NOTIFICATIONS_UPDATING]: updateEmailNotificationsUpdating,
    [UPDATE_EMAIL_NOTIFICATIONS_SUCCESS]: updateEmailNotificationsUpdateSuccess,
    [UPDATE_EMAIL_NOTIFICATIONS_FAIL]: updateEmailNotificationsUpdateFail
};

// ======= Default Action =======
export default function emailNotification(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Selectors =======
export const getEmailNotification = (state, emailNotificationName) => {
    return state.emailNotification.emailNotifications[emailNotificationName];
};

export const getEmailNotifications = (state) => {
    return state.emailNotification.emailNotifications;
};

export const isEmailNotificationFetching = (state) => {
    return state.emailNotification.emailNotificationsFetching;
};

export const didEmailNotificationFetchFail = (state) => {
    return state.emailNotification.emailNotificationsFetchFail;
};

export const isEmailNotificationUpdating = (state) => {
    return state.emailNotification.emailNotificationsUpdating;
};

export const didEmailNotificationUpdateFail = (state) => {
    return state.emailNotification.emailNotificationsUpdateFail;
};

export const didEmailNotificationUpdateSucceed = (state) => {
    return state.emailNotification.emailNotificationsUpdateSuccess;
};

export const didEmailNotificationFetch = (state) => {
    return (
        !state.emailNotification.emailNotificationsFetching &&
        (state.emailNotification.emailNotificationsFetchFail || state.emailNotification.emailNotificationsFetchSuccess)
    );
};

// ======= Actions =======

export function fetchEmailNotifications() {
    return {
        type: FETCH_EMAIL_NOTIFICATIONS
    };
}

export function updateEmailNotification(updatedEmailNotifications) {
    return {
        type: UPDATE_EMAIL_NOTIFICATIONS,
        updatedEmailNotifications: updatedEmailNotifications
    };
}
